export default __webpack_public_path__ + "static/clement-218aef072272b8002abd9bcdba714ffb.webp";